// import React, { useState } from "react";
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogContentText,
//   DialogActions,
//   Button,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   FormHelperText,
//   Box,
//   Typography,
//   FormControlLabel,
//   Radio,
// } from "@mui/material";
// import axios from "axios";
// import { VAVE, UPLOADIL5FILE,CHECKEDIL5 , APPROVEDIL5 } from "../../AppConstant";
// import loadergif from "../../../assets/images/BG-switch loader_2.gif";

// const AlertDialogForm = ({ response, setRefreshApi }) => {


//   const [openAlert, setOpenAlert] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const [selectedFile, setSelectedFile] = useState(null);


  

//   const [inputValue, setInputValue] = useState("");

//   const [alertMessage, setAlertMessage] = useState("");




//   const handleCloseAlert = () => {
//     setOpenAlert(false);
//   };
//   const currentEmpId = localStorage.getItem("empid");


//   const uploadil5File = async (file, request) => {
//     const formData = new FormData();
//     formData.append("filepath", file);
//     formData.append("type", "Excel");
//     formData.append("idea_id", request.idea_id);
//     formData.append("prepared_by_empid", localStorage.getItem("empid"));
//     formData.append("prepared_by", localStorage.getItem("empname"));
  
  

  

//     try {
//       setIsLoading(true);
//       await axios.post(VAVE + UPLOADIL5FILE, formData, {
//         headers: {
//           "Content-Type": "multipart/form-data",
//         },
//       });
//       setSelectedFile(file);
//       alert("File uploaded successfully!");
//     } catch (error) {
//       console.error("Upload error:", error);
//       alert("Upload failed. Please try again.");
//     } finally {
//       setIsLoading(false);
//       setRefreshApi(true);
//     }
//   };


//   const handleFilterByChecked = async (status, request) => {
//     const formData = new FormData();

//     formData.append("idea_id", request.idea_id);
//     formData.append("checked_by_empid", localStorage.getItem("empid"));
//     formData.append("checked_by", localStorage.getItem("empname"));
  
  

  

//     try {
//       setIsLoading(true);
//       await axios.post(VAVE + CHECKEDIL5, formData, {
//         headers: {
//           "Content-Type": "multipart/form-data",
//         },
//       });
//       setSelectedFile(file);
//       alert("Successfully Submitted!");
//     } catch (error) {
//       console.error("Upload error:", error);
//       alert("Upload failed. Please try again.");
//     } finally {
//       setIsLoading(false);
//       setRefreshApi(true);
//     }
//   };

//    const handleFilterByApproved = async (status, request) => {
//     const formData = new FormData();

//     formData.append("idea_id", request.idea_id);
//     formData.append("approved_by_empid", localStorage.getItem("empid"));
//     formData.append("approved_by", localStorage.getItem("empname"));
  
  

  

//     try {
//       setIsLoading(true);
//       await axios.post(VAVE + APPROVEDIL5IL5, formData, {
//         headers: {
//           "Content-Type": "multipart/form-data",
//         },
//       });
//       setSelectedFile(file);
//       alert("Successfully Submitted!");
//     } catch (error) {
//       console.error("Upload error:", error);
//       alert("Upload failed. Please try again.");
//     } finally {
//       setIsLoading(false);
//       setRefreshApi(true);
//     }
//   };

//   const isE3 = currentEmpId === "E3";
//   const isFileValid = !!selectedFile;
//   const isCommentValid = inputValue.trim().length > 0;

//   const onDoneClick = async () => {
//     if (!isFileValid) {
//       setAlertMessage("Please upload file.");
//       setOpenAlert(true);
//       return;
//     }
//     await uploadil5File?.(selectedFile, response);
//   };

//   const onAccept = async () => {
//     if (!isCommentValid) {
//       setAlertMessage(
//         "Please enter a comment before accepting or rejecting. This field is mandatory."
//       );
//       setOpenAlert(true);
//       return;
//     }
//     await handleSubmit?.("accepted", inputValue.trim());
//   };

//   const onReject = async () => {
//     if (!isCommentValid) {
//       setAlertMessage(
//         "Please enter a comment before accepting or rejecting. This field is mandatory."
//       );
//       setOpenAlert(true);
//       return;
//     }
//     await handleSubmit?.("rejected", inputValue.trim());
//   };

//   return (
//     <Box sx={{ padding: "20px", maxWidth: "500px", margin: "0 auto" }}>
//       {isLoading ? (
//         <div
//           style={{
//             position: "fixed",
//             top: 0,
//             left: 0,
//             width: "100%",
//             height: "100%",
//             backgroundColor: "rgba(0, 0, 0, 0.3)",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             zIndex: 9999,
//           }}
//         >
//           <div className="loadergif">
//             <img src={loadergif} alt="Loading..." />
//           </div>
//         </div>
//       ) : (
//         ""
//       )}

//       <Box sx={{ marginTop: "20px" }}>
//         {isE3 ? (
//           <>
//             <Typography variant="body1" sx={{ display: "block", marginBottom: 1 }}>
//               Upload*
//             </Typography>

//             <input
//               type="file"
//               onChange={onFileChange}
//               id="excelUpload"
//               accept=".xlsx,.xls"
//               style={{ marginBottom: "8px", width: "100%" }}
//               disabled={isLoading}
//             />

//             {selectedFile && (
//               <Typography
//                 variant="body2"
//                 color="success.main"
//                 sx={{ marginBottom: 2 }}
//               >
//                 ✓ File uploaded: {selectedFile.name}
//               </Typography>
//             )}

//             <Box sx={{ textAlign: "right" }}>
//               <Button
//                 variant="outlined"
//                 color="error"
//                 onClick={onDoneClick}
//                 disabled={isLoading || !isFileValid}
//               >
//                 Done
//               </Button>
//             </Box>
//           </>
//         ) : (
//           <>
//             <label htmlFor="comment" style={{ display: "block", marginBottom: 8 }}>
//               Comment*
//             </label>

//             <TextField
//               id="comment"
//               placeholder="Enter comment"
//               fullWidth
//               required
//               value={inputValue}
//               onChange={(e) => setInputValue(e.target.value)}
//               size="small"
//             />

//             <div style={{ marginTop: "20px", textAlign: "right" }}>
//               <Button
//                 variant="contained"
//                 color="success"
//                 onClick={onAccept}
//                 style={{ marginRight: "10px" }}
//                 disabled={isLoading}
//               >
//                 Accept
//               </Button>
//               <Button
//                 variant="outlined"
//                 color="error"
//                 onClick={onReject}
//                 disabled={isLoading}
//               >
//                 Reject
//               </Button>
//             </div>
//           </>
//         )}
//       </Box>

//       {/* Unified Alert Dialog */}
//       <Dialog open={openAlert} onClose={handleCloseAlert}>
//         <DialogTitle>Missing Required Field</DialogTitle>
//         <DialogContent>
//           <DialogContentText>{alertMessage}</DialogContentText>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleCloseAlert} autoFocus>
//             OK
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// };

// export default AlertDialogForm;

import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  TextField,
  Box,
  Typography
} from "@mui/material";
import axios from "axios";

import {
  VAVE,
  UPLOADIL5FILE,
  CHECKEDIL5,
  APPROVEDIL5
} from "../../AppConstant";

import loadergif from "../../../assets/images/BG-switch loader_2.gif";

const AlertDialogForm = ({ response, setRefreshApi }) => {
  const [openAlert, setOpenAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");

  const [isLoading, setIsLoading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [inputValue, setInputValue] = useState("");

  const currentEmpId = localStorage.getItem("empid");

  /// dev
  // const isE3 = currentEmpId === "EL_0003"; // Upload IL5 file
  // const isE2 = currentEmpId === "EL_0003"; // Checked
  // const isE1 = currentEmpId === "300381"; // Approved


  /// prd
  const isE3 = currentEmpId === "300088"; // Upload IL5 file
  const isE2 = currentEmpId === "300088"; // Checked
  const isE1 = currentEmpId === "300503"; // Approved

  const handleCloseAlert = () => {
    setOpenAlert(false);
  };

  const onFileChange = (e) => {
    const file = e.target.files?.[0];
    setSelectedFile(file);
  };

  // -------- API Calls ---------

  // E3: Upload IL5 Excel
  const uploadil5File = async (file, status) => {
    const formData = new FormData();
    formData.append("filepath", file);
    formData.append("type", "Excel");
    formData.append("idea_id", response.idea_id);
    formData.append("prepared_by_empid", localStorage.getItem("empid"));
    formData.append("prepared_by", localStorage.getItem("empname"));
    formData.append("checked_by_empid", localStorage.getItem("empid"));
    formData.append("checked_by", localStorage.getItem("empname"));
    formData.append("checked_status", status);
    formData.append("comment", inputValue);

    try {
      setIsLoading(true);
      await axios.post(VAVE + UPLOADIL5FILE, formData);
      alert("IL5 File uploaded successfully!");
    } catch (error) {
      alert("IL5 upload failed");
      console.error(error);
    } finally {
      setIsLoading(false);
      setRefreshApi(true);
    }
  };

  // E2: Checked API
  const submitChecked = async (status) => {
    const formData = new FormData();
    formData.append("idea_id", response.idea_id);
    formData.append("checked_by_empid", localStorage.getItem("empid"));
    formData.append("checked_by", localStorage.getItem("empname"));
    formData.append("checked_status", status);
    formData.append("comment", inputValue);

    try {
      setIsLoading(true);
      await axios.post(VAVE + CHECKEDIL5, formData);
      alert("Successfully Submitted!");
    } catch (error) {
      alert("Checked submission failed");
      console.error(error);
    } finally {
      setIsLoading(false);
      setRefreshApi(true);
    }
  };

  // E1: Approved API
  const submitApproved = async (status) => {
    const formData = new FormData();
    formData.append("idea_id", response.idea_id);
    formData.append("approved_by_empid", localStorage.getItem("empid"));
    formData.append("approved_by", localStorage.getItem("empname"));
    formData.append("approved_status", status);
    formData.append("comment", inputValue);

    try {
      setIsLoading(true);
      await axios.post(VAVE + APPROVEDIL5, formData);
      alert("Successfully Submitted!");
    } catch (error) {
      alert("Approval failed");
      console.error(error);
    } finally {
      setIsLoading(false);
      setRefreshApi(true);
    }
  };

  // -------- Button Actions ---------

  const onDoneClick = async () => {
    if (!selectedFile) {
      setAlertMessage("Please upload IL5 Excel file.");
      setOpenAlert(true);
      return;
    }
    await uploadil5File(selectedFile);
  };

  const onCheckedClick = async (status) => {
    if (!inputValue.trim()  ) {
      setAlertMessage("Comment is required.");
      setOpenAlert(true);
      return;
    }

    else if (!selectedFile) {
      setAlertMessage("Please upload IL5 Excel file.");
      setOpenAlert(true);
      return;
    }
    await uploadil5File(selectedFile , status);
  };

  const onApprovedClick = async (status) => {
    if (!inputValue.trim()) {
      setAlertMessage("Comment is required.");
      setOpenAlert(true);
      return;
    }
    await submitApproved(status);
  };

  // ----------- UI Rendering -----------

  return (
    <Box sx={{ padding: "20px", maxWidth: "500px", margin: "0 auto" }}>
      {/* Loading Overlay */}
      {isLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.3)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999
          }}
        >
          <div className="loadergif">
            <img src={loadergif} alt="Loading..." />
          </div>
        </div>
      )}

      <Box sx={{ marginTop: "20px" }}>
        {/* -------- E3: Upload IL5 section -------- */}
        {isE3 && (
          <>
            <Typography variant="body1" sx={{ marginBottom: 1 }}>
              Upload IL5 File *
            </Typography>

            <input
              type="file"
              accept=".xlsx,.xls"
              onChange={onFileChange}
              disabled={isLoading}
              style={{ marginBottom: "12px", width: "100%" }}
            />

            {selectedFile && (
              <Typography color="success.main" sx={{ marginBottom: 2 }}>
                ✓ {selectedFile.name}
              </Typography>
            )}

            {/* <Box sx={{ textAlign: "right" }}>
              <Button
                variant="contained"
                color="success"
                onClick={onDoneClick}
                disabled={!selectedFile || isLoading}
              >
                Submit IL5
              </Button>
            </Box> */}
          </>
        )}

        {/* -------- E2 & E1: Comment section -------- */}
        {(isE2 || isE1) && (
          <>
            <label style={{ display: "block", marginBottom: 8 }}>Comment *</label>

            <TextField
              fullWidth
              placeholder="Enter your comment"
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
            />

           
             <div style={{ marginTop: "20px", textAlign: "right" }}>
  {isE2 && (
    <>
      <Button
        variant="contained"
        color="error"
        onClick={() => onCheckedClick("rejected")}
        disabled={isLoading}
        style={{ marginRight: "10px" }}
      >
        Rejected
      </Button>

      <Button
        variant="contained"
        color="success"
        onClick={() => onCheckedClick("accepted")}
        disabled={isLoading}
      >
        Checked
      </Button>
    </>
  )}


             <div style={{ marginTop: "20px", textAlign: "right" }}>
  {isE1 && (
    <>
      <Button
        variant="contained"
        color="error"
        onClick={() => onApprovedClick("rejected")}
        disabled={isLoading}
        style={{ marginRight: "10px" }}
      >
        Rejected
      </Button>

      <Button
        variant="contained"
        color="success"
        onClick={() => onApprovedClick("accepted")}
        disabled={isLoading}
      >
        Approved
      </Button>
    </>
  )}
</div>
            </div>
          </>
        )}
      </Box>

      {/* Alert Message Dialog */}
      <Dialog open={openAlert} onClose={handleCloseAlert}>
        <DialogTitle>Missing Required Field</DialogTitle>
        <DialogContent>
          <DialogContentText>{alertMessage}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseAlert}>OK</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default AlertDialogForm;